module.exports = __webpack_public_path__ + "img/Lindsay Cherry walking to campus, 1955.a04968d8.jpg";